import { Injectable } from '@angular/core';
import { Outlet, ParticipantCoupon } from '../models/interfaces';
import { DatabaseService } from './database.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserChangeService } from './user-change.service';
import { User } from 'firebase/auth';
import { CloudfunctriggersService } from './cloudfunctriggers.service';

@Injectable({
  providedIn: 'root'
})
export class CouponsService {
  userCoupons$:BehaviorSubject<ParticipantCoupon[]> = new BehaviorSubject([])
  private _coupons:ParticipantCoupon[] = []
  get coupons(){
    return this._coupons
  }
  private _user:User
  private couponsSubscription:Subscription
  constructor(
    private database: DatabaseService,
    private userChangeService:UserChangeService,
    private cloudFunctionTriggers:CloudfunctriggersService
  ) { 
    this.userChangeService.user$.subscribe((user) => {
      if(!user) return;
      this._user = user
      this.listenToUserCoupons(true);
    });
  }

  async listenToUserCoupons(force=false){
    if(force && this.couponsSubscription){
      this.couponsSubscription.unsubscribe();
    }
    if(!this.couponsSubscription||this.couponsSubscription.closed){
      this.database.listenToUserCoupons(this.userCoupons$);
      this.couponsSubscription = this.userCoupons$.subscribe((coupons)=>{
        this._coupons = coupons
      })
    }else{
      console.log('Already listening. subscribe to the active subject instead');
    }
  }

  claimCoupon(coupon_id:string){
      return this.cloudFunctionTriggers.claimCoupon(coupon_id);
  }

  async redeemCoupon(coupon: ParticipantCoupon,lat:number,lng:number,outlet:Outlet){
    let couponRedeemed = false
    const now = new Date().getTime();
    await this.database.redeemCoupon(coupon,now,lat,lng,outlet);
    couponRedeemed = true;
    return couponRedeemed
  };

}
